
import QRCode from 'qrcode';

export const generateQrCode = async (text: string): Promise<string> => {
    try {
        return await QRCode.toDataURL(text, { errorCorrectionLevel: 'M', margin: 2, width: 80 });
    } catch (err) {
        console.error(err);
        return '';
    }
};
